import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {ImageActiveTable, ImageCompletedTable} from './ImageTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const ImageTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});

  const tabs = {
    active: {
      label: 'Active',
      view: <ImageActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <ImageCompletedTable searchValue={searchValue} />,
    },
  };

  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
